
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import VueTagsInput from '@johmun/vue-tags-input';
import { ITag, TagType } from './TagModel';
import TribeIcon from '../shared/TribeIcon.vue';
import HiveIcon from "../shared/HiveIcon.vue";

@Component({
    components: {
        VueTagsInput,
        TribeIcon,
        HiveIcon
    }
})
export default class GenericSearchBar extends Vue {
    private currentSearchQuery = '';

    @Prop()
    tags: ITag[];
    @Prop()
    selectedTags: ITag[];

    @Emit('tagsChanged')
    onTagsChanged(tags: ITag[]) {}

    beforeTagAdded(event: { tag: ITag; addTag: () => void }) {
        this.$emit('tagAdded', event.tag);
        event.addTag();
    }

    beforeTagRemoved(event: { tag: ITag; deleteTag: () => void }) {
        this.$emit('tagRemoved', event.tag);
        event.deleteTag();
    }

    get filteredTags(): ITag[] {
        // match on current search query and then sort on the index of the match
        let exp = new RegExp(this.currentSearchQuery, 'i');
        return this.tags
            .map(tag => {
                return {
                    match: exp.exec(tag.text),
                    tag
                };
            })
            .filter(item => !!item.match)
            .sort(
                (a, b) =>
                    a.match.index !== b.match.index
                        ? a.match.index - b.match.index
                        : a.tag.text.localeCompare(b.tag.text)
            )
            .map(item => item.tag)
            .slice(0, 20);
    }

    public isDuplicateTag(tags: ITag[], tag: ITag): boolean {
        return tags.some(t => t.tagType === tag.tagType && t.text === tag.text);
    }

    public getIconType(tag: ITag): string {
        if (tag.tagType === TagType.Tribe || tag.tagType === TagType.Hive) {
            return 'img';
        } else {
            return 'class';
        }
    }

    public getIconClass(tag: ITag): string {
        switch (tag.tagType) {
            case TagType.Person:
                return 'fa-user';
            case TagType.Skill:
                return 'fa-tag';
            case TagType.Account:
                return 'fa-briefcase';
            case TagType.AccountCluster:
                return 'fa-sitemap';
            case TagType.Seniority:
                return 'fa-line-chart';
            case TagType.Profile:
                return 'fa-id-card';
            default:
                return '';
        }
    }

    public getIconComponent(tag: ITag): string {
        switch (tag.tagType) {
            case TagType.Tribe:
                return 'TribeIcon';
            case TagType.Hive:
                return 'HiveIcon';
            default:
                return '';
        }
    }
}
